import {SET_EMERGENCY} from "./EmergencyTypes";
import TransformShop from "../../transforms/TransformShop";


export function emergencyReducer(state = TransformShop._toEmergencyBrake(), action) {
    switch (action.type) {
        case SET_EMERGENCY :
            return TransformShop._toEmergencyBrake(action.data);
        default:
            return state;
    }
}
